// store/orderStore.ts
import { createApiStore, GenericStore } from "./genericStore";
import { Order } from "../types/order";
import api from "../service/api";

// 1. Yeni Metodu Tanımlayan Interface
interface OrderStore extends GenericStore<Order> {
  convertToInvoice: (orderId: number) => Promise<any>;
  convertToTask: (orderId: number) => Promise<any>;
}

// 2. Store Oluşturma
export const useOrderStore = createApiStore<Order>("/order") as unknown as () => OrderStore;

// 3. Mevcut store'a özel aksiyonu ekleyelim (Extra Actions)
// Bu kısmı createApiStore'un içinde veya dışında tanımlayabilirsin. 
// En temiz yol, generic store dönerken bunu extend etmektir.
// Ancak mevcut yapında şöyle bir ekleme yapabiliriz:

const useOrderStoreBase = useOrderStore as any;

useOrderStoreBase.setState((state: any) => ({
  ...state,
  convertToInvoice: async (orderId: number) => {
    try {
      // Generic store'daki loading ve error state'lerini kullanalım
      useOrderStoreBase.setState({ loading: true, error: null });
      
      const res = await api.post(`/order/${orderId}/invoice`);
      
      // Faturadan sonra sipariş listesini ve detaylarını güncelle
      await useOrderStoreBase.getState().fetchDataDynamic();
      
      useOrderStoreBase.setState({ loading: false });
      return res.data;
    } catch (err: any) {
      // genericStore'daki hata yönetimi mantığını burada da işletelim
      const errorMessage = err.response?.data?.message || "Faturalandırma sırasında bir hata oluştu";
      useOrderStoreBase.setState({ 
        error: { message: errorMessage, details: err.response?.data?.details || null }, 
        loading: false 
      });
      throw err;
    }
  },
  
  convertToTask: async (orderId: number) => {
    try {
      useOrderStoreBase.setState({ loading: true, error: null });
      
      const res = await api.post(`/order/${orderId}/convertToTask`);
      
      // Görevden sonra sipariş listesini ve detaylarını güncelle
      await useOrderStoreBase.getState().fetchDataDynamic();
      
      useOrderStoreBase.setState({ loading: false });
      return res.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Görev oluşturma sırasında bir hata oluştu";
      useOrderStoreBase.setState({ 
        error: { message: errorMessage, details: err.response?.data?.details || null }, 
        loading: false 
      });
      throw err;
    }
  }
}));